//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { getStateHref } from '@react-bridge/wrappers/navigation';
import { RoutableStateName } from 'app/top-level-states';

export const getPostLoginRedirect = createSelector(
    (state: ICuralateStore) => state.routing.redirectedFrom,
    (redirectedFrom) => {
      if (!redirectedFrom) {
        // No recorded redirect information.
        return undefined;
      }
      if (redirectedFrom.initialUrlTraits) {
        const { stateFromCognito, rawPathAndParams } = redirectedFrom.initialUrlTraits;
        // Use a redirect state from cognito if one is available. Otherwise, use the initial url when the page loaded.
        if (stateFromCognito) {
          // We were definitely redirected from cognito.
          // Use the login redirect, or default to `/`.
          return stateFromCognito.loginRedirect ?? '/';
        }
        return rawPathAndParams;
      }
      // Fallback behavior: Build the URL manually from state & params data.
      return getStateHref(redirectedFrom.state.name as RoutableStateName, redirectedFrom.params);
    },
);
